import React from 'react';

import { Divider } from '~shared/components/Divider';

export function MenuDivider() {
  return (
    <div className="py-3">
      <Divider />
    </div>
  );
}
